export default __webpack_public_path__ + "static/media/greenimg.c9bb557c.jpg";